module.exports = __webpack_public_path__ + "img/add-icon.a7e97df6.svg";